import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

import { paperPadding } from 'styles/commonStyles';
import Alarm from './Alarm/Alarm';
import Profile from './Profile/Profile';
import pageMenu from 'constants/pageMenu';
import Button from 'components/ui/Button';
import useProjectCreate from 'hooks/useProjectCreate';

const Container = styled.header`
  ${paperPadding};
  height: 90px;
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.home.bgColor};
  z-index: 999;
`;

const LeftArea = styled.div``;

const PageName = styled.h1`
  font-size: 26px;
  font-weight: 600;
`;

const RightArea = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Header = () => {
  const { pathname } = useLocation();
  const { onCreateClick } = useProjectCreate();
  return (
    <Container>
      <LeftArea>
        <PageName>{pageMenu[pathname].name}</PageName>
      </LeftArea>
      <RightArea>
        <Button $height={46} onClick={onCreateClick}>
          새 프로젝트 만들기
        </Button>
        <ButtonArea>
          <Alarm />
          <Profile />
        </ButtonArea>
      </RightArea>
    </Container>
  );
};

export default Header;
